export enum KeycloakEmailValidationError {
  EmptyValue = "EMPTY_VALUE",
  InvalidEmailId = "INVALID_EMAIL_ID",
}
